import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { CONTACT } from "@/data/content";

const Footer = () => (
  <footer className="border-t border-[#282E3F] bg-[#0B0D12]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Logo />
        <p className="mt-6 font-display text-xl text-slate-200 tracking-tight">Building Opportunities for a Better Tomorrow.</p>
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">
          A multi-disciplinary institutional infrastructure enterprise spanning strategic real estate and mission-critical digital systems.
        </p>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-400/90 mb-5">Divisions</p>
        <div className="flex flex-col gap-3 text-sm">
          <Link to="/infrastructure" data-testid="footer-infra-link" className="text-slate-300 hover:text-sky-400 transition-colors">
            Strategic Infrastructure &amp; Real Estate
          </Link>
          <Link to="/technology" data-testid="footer-tech-link" className="text-slate-300 hover:text-sky-400 transition-colors">
            Advanced Intelligence &amp; Digital Systems
          </Link>
          <Link to="/contact" data-testid="footer-contact-link" className="text-slate-300 hover:text-sky-400 transition-colors">
            Institutional Enquiries
          </Link>
        </div>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-400/90 mb-5">Head Office</p>
        <p className="text-sm text-slate-300 font-medium">{CONTACT.headOffice}</p>
        <p className="mt-2 text-sm text-slate-400 leading-relaxed" data-testid="footer-address">{CONTACT.address}</p>
        <p className="mt-3 font-mono text-xs text-slate-500 tracking-wider">{CONTACT.operations}</p>
      </div>
    </div>
    <div className="border-t border-[#282E3F]/70">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[11px] tracking-wider text-slate-500">© {new Date().getFullYear()} CRESTMONT ENTERPRISES PRIVATE LIMITED</p>
        <p className="font-mono text-[11px] tracking-wider text-slate-500">BACKEND TECHNICAL SYSTEMS · EXCLUDING WEB-PAGE DESIGNING</p>
      </div>
    </div>
  </footer>
);

export default Footer;
